import {
	Box,
	Alert,
	AlertIcon,
	AlertTitle,
	CloseButton,
	SlideFade,
	useDisclosure,
} from '@chakra-ui/react';
import { Toast, ToastStatus } from 'models/types';

export interface AlertPopupProps {
	toast: Toast;
}


interface ToastColorConfig {
	iconColor: string;
	iconBg: string;
	bg: string;
	borderColor: string;
	textColor: string;
	closeColor: string;
}


export default function AlertPopup({ toast }: AlertPopupProps) {
	const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });
	const defaultStatus = 'info'

	const styleMap: Record<ToastStatus, ToastColorConfig> = {
		'error': {
			iconColor: 'white',
			iconBg: 'red.700',
			bg: 'red.50',
			borderColor: 'red.700',
			textColor: 'red.700',
			closeColor: 'red.700',
		},
		'warning': {
			iconColor: 'white',
			iconBg: 'yellow.700',
			bg: 'yellow.50',
			borderColor: 'yellow.700',
			textColor: 'yellow.700',
			closeColor: 'yellow.700',
		},
		'success': {
			iconColor: 'white',
			iconBg: 'green.700',
			bg: 'green.50',
			borderColor: 'green.700',
			textColor: 'green.700',
			closeColor: 'green.700',
		},
		'info': {
			iconColor: 'white',
			iconBg: 'blue.700',
			bg: 'blue.50',
			borderColor: 'blue.700',
			textColor: 'blue.700',
			closeColor: 'blue.700',
		},
	};

	const style = styleMap[toast.status || defaultStatus];

	return isOpen ? (
		<SlideFade in={isOpen} unmountOnExit>
			<Alert
				status={toast.status}
				bg={style.bg}
				border="1px solid"
				borderColor={style.borderColor}
				borderRadius="md"
				maxW="420px"
				alignItems="center"
				px={4}
				py={3}
			>
				<Box
					bg={style.iconBg}
					color={style.iconColor}
					borderRadius="8px"
					w="8"
					h="8"
					display="flex"
					alignItems="center"
					alignContent="center"
					justifyContent="center"
					mr={2}
				>
					<AlertIcon boxSize={4} color="white" marginInlineEnd={0} />
				</Box>

				<AlertTitle fontWeight="bold" color={style.textColor} flex="1" fontSize="md">
					{toast.title}
				</AlertTitle>

				<CloseButton
					size="sm"
					color={style.closeColor}
					onClick={onClose}
				/>
			</Alert>
		</SlideFade>
	) : null;
}
